import RejectIconUrl from "assets/icons/reject-red.svg?url";
import WarningIconUrl from "assets/icons/exclamation-round-color.svg?url";
import { date } from "quasar";
const { formatDate } = date;
export const CURRENCY = {
  code: "INR",
  name: "Indian Rupee",
  symbol: "₹",
};

export const ENTRY_POINT = {
  name: "sales-purchase-orders",
};

export const FILE_TYPE_MAP = {
  "E-Invoice": {
    entity: "invoice",
    key: "invc_id",
    label: "E-Invoice",
  },
  "E-Way Bill": {
    entity: "ewb",
    key: "ewaybill_id",
    label: "E-Way Bill",
  },
  "Purchase Order": {
    entity: "purchaseOrder",
    key: "po_id",
    label: "Purchase Order",
  },
  "Purchase Bill": {
    entity: "purchaseBill",
    key: "bill_id",
    label: "Purchase Bill",
  },
  "Proof of Delivery": {
    entity: "pod",
    key: "pod_id",
    label: "Proof of Delivery",
  },
  "Credit Note": {
    entity: "creditNote",
    key: "cn_id",
    label: "Credit Note",
  },
  "Debit Note": {
    entity: "debitNote",
    key: "dn_id",
    label: "Debit Note",
  },
  "Quality Check": {
    entity: "qualityCheck",
    key: "qc_id",
    label: "Quality Check",
  },
  "Deal Terms": {
    entity: "dealSetting",
    key: "deal_setting_id",
    label: "Deal Terms",
  },
  "Payment Advice": {
    entity: "customerPayment",
    key: "cp_id",
    label: "Payment Advice",
  },
};

export const PRODUCT_MARGIN = {
  default: {
    min: 0.3,
    max: 2,
  },
  range: {
    min: 0.3,
    max: 9.9,
  },
};

export const FORM_INFO = "✍️ Fields marked with * are mandatory";

export const NO_OPTIONS_TEXT = {
  bills:
    "No eligible Purchase bills found. Please check if there are any active Purchase bills.",
  invoices:
    "No eligible invoices found. Please check if there are any active PODs",
  refInvoices:
    "No eligible invoices found. Please check if there are any invoices linked with active POD",
};

export const ICON_PATH = {
  negative: `img:${RejectIconUrl}`,
  warning: `img:${WarningIconUrl}`,
};

export const BANK_CSV_COLUMNS = {
  HDFC: [
    "Transaction Type (N – NFET, R – RTGS & I - Fund Transfer in HDFC Bank account)",
    "Beneficiary Code (Mandatory In case of Fund Transfer only)",
    "Beneficiary Account Number", // seller_info.bank_account_number
    "Instrument Amount", //  net_payable
    "Beneficiary Name (Upto 40 character without any special character)", // seller_info.bank_beneficiary_name
    "Drawee Location",
    "Print Location",
    "Bene Address 1",
    "Bene Address 2",
    "Bene Address 3",
    "Bene Address 4",
    "Bene Address 5",
    "Instruction Reference Number",
    "Customer Reference Number(Which needs to be reflected in statement upto character upto 20)",
    "Payment details 1",
    "Payment details 2",
    "Payment details 3",
    "Payment details 4",
    "Payment details 5",
    "Payment details 6",
    "Payment details 7",
    "Cheque Number",
    "Chq / Trn Date (DD/MM/YYYY)",
    "MICR Number",
    "IFSC Code", // seller_info.bank_ifsc
    "Bene Bank Name", // seller_info.bank_name
    "Bene Bank Branch Name",
    "Beneficiary email id",
  ],

  IDFC: [
    "Client Code",
    "Debit account no.",
    "Transaction type code",
    "Value date",
    "Amount", // net_payable

    "Beneficary Name", // seller_info.bank_beneficiary_name
    "Beneficary Accunt no.", // seller_info.bank_account_number
    "IFSC code", // seller_info.bank_ifsc
    "Customer Ref no.",
    "Beneficary email id",
    "Beneficiary mobile no.",
    "Remarks",
    "Payment Type",
    "Purpose code",
    "Bene a/c type",
    "Payable Location",
    "Print branch name",
    "Mode of delivery",
    "Transaction currency",
    "BENE_ADD1",
    "BENE_ADD2",
    "BENE_ADD3",
    "BENE_ADD4",
    "BENE_ID",
  ],
};

export const SELLER_INFO_MAPPINGS = {
  "Beneficiary Name (Upto 40 character without any special character)":
    "bank_beneficiary_name",
  "IFSC Code": "bank_ifsc",
  "Beneficary Name": "bank_beneficiary_name",
  "Beneficary Accunt no.": "bank_account_number",
  "Beneficiary Code (Mandatory In case of Fund Transfer only)":
    "bank_account_number",
  "Beneficiary Account Number": "bank_account_number",
  "Bene Bank Name": "bank_name",
  Vendor: "shop_name",
  "Bank Account": "bank_account_number",
  IFSC: "bank_ifsc",
};

export const CSV_COLUMNS_DATA_MAPPINGS = {
  BULK_INITIATE: {
    "Instrument Amount": "net_payable",
    "Value date": formatDate(new Date(), "DD-MM-YYYY"),
    Amount: "net_payable",
    "Payment Type": "RTGS",
    "Transaction type code": "RTGS",

    // hardcoded
    "Purpose code": "CMS",
    "Bene a/c type": "11",
    "Mode of delivery": "BP",
    "Transaction currency": "INR",

    "Transaction Type (N – NFET, R – RTGS & I - Fund Transfer in HDFC Bank account)":
      "N(NEFT)",
    "Chq / Trn Date (DD/MM/YYYY)": formatDate(new Date(), "DD/MM/YYYY"),
  },

  BULK_PROCESS: {
    ID: "_id",
    "Request ID": "internal_number",
    Vendor: "",
    "Purchase Bill Number": "bill_number",
    "Purchase Bill Date": "bill_date",
    "Net Payable": "net_payable",
    "Poshn Bank Code": "bank_codes",
    "Payment Date": formatDate(new Date(), "DD/MM/YYYY"),
    UTR: "",
    Description: "",
    MODE: "RTGS|NEFT|IMPS",
    Status: "status_cd",
    Reason: "reason",
  },
};

export const BULK_PROCESS_HEADERS = [
  "ID",
  "Request ID",
  "Vendor",
  "Purchase Bill Number",
  "Purchase Bill Date",
  "Net Payable",
  "Poshn Bank Code",
  "Payment Date",
  "UTR",
  "Description",
  "MODE",
  "Bank Account",
  "IFSC",
  "Status",
  "Reason",
];

export const stages = [
  "POD Pending",
  "POD Received",
  "POD Rejected",
  "POD Accepted",
  "QC Received",
  "QC Rejected",
  "QC Accepted",
];

export const stageToLabelMappings = {
  "POD Pending": "PODs Pending",
  "POD Received": "PODs Received",
  "POD Rejected": "PODs Rejected",
  "POD Accepted": "PODs Accepted",
  "QC Received": "QCs Received",
  "QC Rejected": "QCs Rejected",
  "QC Accepted": "QCs Accepted",
};

export const stageToStageCodeMappings = {
  "Not Started": "pending",
  "POD Pending": "pod_pending",
  "POD Received": "pod_received",
  "POD Rejected": "pod_rejected",
  "POD Accepted": "pod_accepted",
  "QC Received": "qc_received",
  "QC Rejected": "qc_rejected",
  "QC Accepted": "qc_accepted",
};

export const stageCodeToStageMappings = {
  pending: "Not Started",
  pod_pending: "POD Pending",
  pod_received: "POD Received",
  pod_rejected: "POD Rejected",
  pod_accepted: "POD Accepted",
  qc_received: "QC Received",
  qc_rejected: "QC Rejected",
  qc_accepted: "QC Accepted",
  in_progress: "Not Started",
  completed: "Completed",
};

export const invoiceStages = [
  "pending",
  "pod_pending",
  "pod_received",
  "pod_rejected",
  "pod_accepted",
  "qc_received",
  "qc_rejected",
  "qc_accepted",
];

export const stageToCtaPropsMappings = {
  "POD Received": {
    label: "Reject POD",
  },
  "QC Received": {
    label: "Reject QC",
  },
};

export const podRejectionReasons = [
  {
    _id: "Vehicle Info Error: incorrect, missing or unclear vehicle number",
    name: "Vehicle Info Error: incorrect, missing or unclear vehicle number",
  },
  {
    _id: "Quantity mismatches (POD vs Bill of supply)",
    name: "Quantity mismatches (POD vs Bill of supply)",
  },
  {
    _id: "POD File error: missing pages",
    name: "POD File error: missing pages",
  },
  {
    _id: "POD File error: incorrect uploads",
    name: "POD File error: incorrect uploads",
  },
  {
    _id: "Missing POD Details: date not mentioned",
    name: "Missing POD Details: date not mentioned",
  },
  {
    _id: "Missing POD Details: missing signatures or stamps",
    name: "Missing POD Details: missing signatures or stamps",
  },
  {
    _id: "Others",
    name: "Others",
    helperText: "Reason missing? Select this option.",
  },
];

export const qcRejectionReasons = [
  {
    _id: "Quantity mismatches (QC vs Bill of supply)",
    name: "Quantity mismatches (QC vs Bill of supply)",
  },
  {
    _id: "QC File error: missing pages",
    name: "QC File error: missing pages",
  },
  {
    _id: "QC File error: incorrect uploads",
    name: "QC File error: incorrect uploads",
  },
  {
    _id: "Missing QC Details: date not mentioned",
    name: "Missing QC Details: date not mentioned",
  },
  {
    _id: "Missing QC Details: missing signatures or stamps",
    name: "Missing QC Details: missing signatures or stamps",
  },
  {
    _id: "Others",
    name: "Others",
    helperText: "Reason missing? Select this option.",
  },
];

export const rejectPODProps = {
  note: "NOTE: Invoice moves to POD rejected stage.\n POD and associated CN will get cancelled automatically!",
  form: {
    dropdown: {
      placeholder: "Select reason to reject POD",
      help: "Why do you want to reject the POD against this invoice? Please Select!",
    },
  },
};

export const rejectQCProps = {
  note: "NOTE: Invoice moves to QC rejected stage.\n Quality Check Report, associated CN and  associated DN will get cancelled automatically!",
  form: {
    dropdown: {
      placeholder: "Select reason to reject quality check report",
      help: "Why do you want to reject the quality check report against this invoice? Please Select!",
    },
  },
};

export const confirmationDialogTextMapping = {
  "POD Received": {
    ACCEPT: {
      title: `Accept proof of delivery`,
      submitLabel: "Accept POD",
      text: "Are you sure you want to accept this proof of delivery?",
    },
    REJECT: {
      text: "Are you sure you want to reject the POD",
    },
  },
  "QC Received": {
    ACCEPT: {
      title: `Accept Quality Check Report`,
      submitLabel: "Accept QC",
      text: "Are you sure you want to accept this Quality Check Report?",
    },
    REJECT: {
      text: "Are you sure you want to reject the Quality Check Report",
    },
  },
};
